import React from 'react'
import Select from 'react-select';
import { Form, Col, Media, Table, Button } from 'reactstrap';
import { PlaceHolderOption } from '../../constant';
import { Dialog } from 'primereact/dialog';


export const ModalDevolution = (props) => {

    const {
        devolutionsState,
        modalDevolutions,
        number_format,
        listReturnReason,
        handleChangeReturnReason,
        saveReturnReason,
        canceldevolution,
        loadingDevolution
    } = props;

    let versionLayout = localStorage.getItem('layout_version');

    return (
        <Dialog
            visible={modalDevolutions}
            onHide={canceldevolution}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-undo f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Devoluciones
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v22`}
            footer={
                <div>
                    <Button
                        color="secondary text-center"
                        type="button"
                        onClick={saveReturnReason}
                        disabled={loadingDevolution ? true : false}
                    >
                        Autorizar
                    </Button>

                    <Button
                        color="danger text-center"
                        type="button"
                        onClick={canceldevolution}
                        disabled={loadingDevolution ? true : false}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        >

            <Form className="" role="form">
                <Col sm="12" className='pt-2 p-l-0 p-r-0' >
                    <Media><Media className="img-100 img-fluid m-r-20 rounded-circle" src={require("../../assets/images/typeService.svg")} alt="" />
                        <Media body className='pt-3' >
                            <span className="d-block"><span><span className=" f-w-600 f-12">{"Selecciona un motivo del catalógo"}
                                <Col sm="12" className='pt-2 p-l-0 p-r-0' >
                                    <Select
                                        classNamePrefix="select"
                                        name="id_return_reason"
                                        value={devolutionsState.id_return_reason}
                                        options={listReturnReason}
                                        placeholder={PlaceHolderOption}
                                        isClearable={true}
                                        onChange={(e) => handleChangeReturnReason(e)}
                                        theme={
                                            (theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: (versionLayout === 'dark-only') ? '#4c9aff' : "#deebff"
                                                }
                                            })
                                        }
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}

                                    />
                                </Col>
                            </span></span></span>
                        </Media>
                    </Media>
                    <Col sm="12" className='pt-2' >
                        <b className='f-w-600 pb-2 f-12' >Listado de devolución</b>
                        <Col sm="12" className='pt-2 p-l-0 p-r-0' >
                            <Table className='table-sm'>
                                <thead>
                                    <tr className='text-center' style={{ backgroundColor: "#002940", color: "#fff" }} >
                                        <th style={{ color: "#fff", textAlign: "justify" }} >Examen / Perfil</th>
                                        <th style={{ color: "#fff", textAlign: "right" }} >Total de devolución</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        devolutionsState.listTestDevolution.length > 0
                                            ?
                                            devolutionsState.listTestDevolution.map((_amount) => {
                                                return (
                                                    <tr key={_amount?.id_work_order_exam === null ? _amount?.id_work_order_profile : _amount?.id_work_order_exam}>
                                                        <td>{_amount?.code + " " + _amount?.name}</td>
                                                        <td className='text-right'> {_amount?.config_iva ? <b>$ {`${number_format(_amount?.amount, 2)}`}</b> : <b>$ {`${number_format(Math.round(_amount?.amount + _amount?.extra + _amount?.iva), 2)}`}</b>
                                                        }</td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td className='text-center p-1' colSpan={2}>
                                                    <p>No se ha registrado ninguna devolución</p>
                                                    <p className='text-danger'><i className="fa fa-times-circle"></i></p>
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Col>
                </Col>
            </Form>
        </Dialog>



    )
}

